import { Link } from '@tanstack/react-router';
import { Copy, FileUp, Plus, UserPlus, type LucideIcon } from 'lucide-react';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

type Action = {
  label: string;
  description: string;
  to: string;
  icon: LucideIcon;
};

const actions: Action[] = [
  { label: 'New Job', description: 'Add a job manually', to: '/admin/jobs/new', icon: Plus },
  {
    label: 'Bulk Upload',
    description: 'Import from a file',
    to: '/admin/jobs/bulk-upload',
    icon: FileUp,
  },
  {
    label: 'Add Customer',
    description: 'Onboard a client',
    to: '/admin/customers/new',
    icon: UserPlus,
  },
  {
    label: 'Review Duplicates',
    description: 'Resolve flagged jobs',
    to: '/admin/jobs/duplicates',
    icon: Copy,
  },
];

export function QuickActions() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
        <CardDescription>Jump straight into common tasks</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {actions.map((action) => (
            <Link
              key={action.label}
              to={action.to}
              className="group flex items-center gap-3 rounded-lg border bg-card p-3 text-left transition-colors duration-200 hover:border-primary/40 hover:bg-accent"
            >
              <span className="flex size-9 items-center justify-center rounded-md bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                <action.icon className="size-5" aria-hidden />
              </span>
              <div className="min-w-0">
                <p className="text-sm font-medium">{action.label}</p>
                <p className="truncate text-xs text-muted-foreground">{action.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
